import { TEMP_ATTRIBUTES_CODES } from "@/vue/constants/attribute-types";
import {getTankTypeTranslationKey, getTemperatureSensorTypeTranslationKey} from "@/utils/devices";

/**
 * @ngdoc Controller
 * @name AlarmsSettingsController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('AlarmsSettingsController', AlarmsSettingsController);

    /**
     * @constructor
     * @ngInject
     */
    function AlarmsSettingsController($log, $scope, $stateParams, ApiService, $q, InstallationsService, vrmNotificationsService, vrmNotificationType, locale, UserService) {
        $log.info('AlarmsSettingsController');
        $scope.forms = {};
        $scope.tempCodes = TEMP_ATTRIBUTES_CODES;
        $scope.nodataalarm = {
            collapsed: false
        };

        $scope.automaticalarm = {
            collapsed: false
        };

        $scope.bypassSubmitted = true;

        $scope.myUser = {id: null};
        $scope.symbol = '°C';

        UserService.getUser().then(function (user) {
            $scope.myUser = user;
            $scope.symbol = user.useFahrenheit ? '°F' : '°C';
        });

        locale.ready('installationoverview').then(() => {
            $q.all([
                InstallationsService.getInstallation($stateParams.id),
                ApiService.installations($stateParams.id, 'alarms'),
            ]).then((result) => {
                const installation = result[0];
                const response = result[1];

                $scope.nodataalarm['noDataAlarmActive'] = installation.noDataAlarmTimeout != null;
                $scope.nodataalarm['noDataAlarmTimeout'] = installation.noDataAlarmTimeout;
                $scope.automaticalarm['alarmMonitoring'] = installation.alarmMonitoring;

                $scope.attributes = {};
                // create referenced list by data attribute code
                _.each(response.data.attributes, function (dataAttribute) {
                    $scope.attributes[dataAttribute.idDataAttribute] = dataAttribute;
                });

                _.each(response.data.alarms, function (alarm) {
                    _.each(['highAlarm', 'highAlarmHysteresis', 'lowAlarm', 'lowAlarmHysteresis', 'NotifyAfterSeconds'], function (property) {
                        if (alarm[property]) {
                            alarm[property] = parseFloat(alarm[property]);
                        }
                    });
                });

                const alarmDeviceDict = addCustomNamesToAlarms(response, installation);
                $scope.alarms = response.data.alarms;
                $scope.rateLimited = response.data.rateLimited;

                for (var i in $scope.alarms) {
                    var alarm = $scope.alarms[i];
                    //Create copy for change comparison
                    $scope.alarms[i].copy = _.clone($scope.alarms[i]);

                    // Add custom names to the actual alarm objects.
                    const key = `${alarm.meta_info.idDeviceType}/${alarm.instance}`;
                    const entry = alarmDeviceDict[key];

                    if (entry.meta_info.customName) {
                        alarm.meta_info.customName = entry.meta_info.customName;
                    }

                    if (entry.meta_info.typeName) {
                        alarm.meta_info.typeName = entry.meta_info.typeName;
                    }

                    if (alarm.idDataAttribute && $scope.attributes[alarm.idDataAttribute].dataType == 'enum') {
                        alarm.toggles = {};
                        for (var n in $scope.attributes[alarm.idDataAttribute].enumValues) {
                            alarm.toggles[$scope.attributes[alarm.idDataAttribute].enumValues[n].valueEnum] = true;
                        }

                        for (var n in alarm.active) {
                            alarm.toggles[alarm.active[n]] = false;
                        }
                    }
                }

                $scope.users = response.data.users;
                for (var index in $scope.users) {
                    $scope.users[index].alarms = $scope.users[index].receivesAlarmNotifications == 1;
                }

                //Update access level of user based on the value of the toggle
                $scope.updateReceiveAlarm = function (user) {
                    var receivesAlarmNotifications = user.alarms ? 1 : 0;
                    return ApiService.installations($stateParams.id, 'alarm-user/' + user.idUser, {
                        receivesAlarmNotifications: receivesAlarmNotifications
                    }, 'PUT').then(function () {
                        user.receivesAlarmNotifications = receivesAlarmNotifications;
                    });
                }

                function updateAlarm(alarm) {
                    var data = _.pick(alarm, "idDataAttribute", "instance");

                    if (alarm.idDataAttribute && $scope.attributes[alarm.idDataAttribute].dataType == 'enum') {
                        _.extend(data, _.pick(alarm, "notifyAfterSeconds", "alarmEnabled", "enumValues"));
                        data['enumValues'] = alarm.active;
                    } else if (alarm.idDataAttribute && $scope.attributes[alarm.idDataAttribute].dataType == 'float') {
                        _.extend(data, _.pick(alarm, "idDataAttributeLimit", "NotifyAfterSeconds", "AlarmEnabled", "lowAlarm", "lowAlarmHysteresis", "highAlarm", "highAlarmHysteresis"));
                    }

                    return ApiService.installations($stateParams.id, 'alarms', data, 'PUT').then(function () {
                        //Update local copy with new changes
                        alarm.copy = _.omit(alarm, 'copy', 'toggles', 'collapsed', '$$hashKey');
                    });
                }

                function addCustomNamesToAlarms(response, installation) {
                    const devices = response.data.devices;
                    var alarms = response.data.alarms;
                    var alarmDict = {};

                    for (const alarm of alarms) {
                        //create dict with device_type and instance as key
                        let key = alarm.meta_info.idDeviceType + '/' + alarm.instance; //make combined dict key as unique so we reduce iterations from n * n to n + n
                        alarmDict[key] = alarm;
                    }

                    for (const device of devices) {
                        const deviceTypeId = device.idDeviceType;

                        const key = deviceTypeId + '/' + device.instance;

                        const { tst, tf } = installation.data;
                        const deviceTypeIdTempSensor = 17;
                        const deviceTypeIdTank = 5;

                        if (alarmDict[key] !== undefined) {
                            // Set the type name for the temperature sensor if it is not generic.
                            if (deviceTypeId === deviceTypeIdTempSensor) {
                                const type = tst && tst.instances[device.instance];

                                if (type) {
                                    const typeId = type.rawValue;
                                    const translationKey = getTemperatureSensorTypeTranslationKey(typeId);

                                    // Exclude Generic sensors
                                    if (translationKey) {
                                        alarmDict[key].meta_info.typeName = `${locale.getString(translationKey)} [${device.instance}]`;
                                    }
                                }
                            }

                            // Tanks
                            if (deviceTypeId === deviceTypeIdTank) {
                                const type = tf && tf.instances[device.instance];

                                if (type) {
                                    const typeId = type.rawValue;
                                    const translationKey = getTankTypeTranslationKey(typeId);

                                    if (translationKey) {
                                        alarmDict[key].meta_info.typeName = `${locale.getString(translationKey)} [${device.instance}]`;
                                    }
                                }
                            }

                            if (device.customName !== null) {
                                //setting custom name object
                                alarmDict[key].meta_info.customName = device.customName;
                            }
                        }
                    }

                    return alarmDict;
                }

                $scope.delete = function (alarm) {
                    ApiService.installations($stateParams.id, 'alarms', {
                        idDataAttribute: alarm.idDataAttribute,
                        instance: alarm.instance
                    }, 'DELETE').then(function () {
                        locale.ready('alarms').then(function () {
                            $scope.alarms = _.filter($scope.alarms, function (row) {
                                return row.idDataAttribute != alarm.idDataAttribute && row.instance != alarm.instane;
                            });
                            vrmNotificationsService.add({
                                type: vrmNotificationType.SUCCESS,
                                message: locale.getString('alarms.alarm_deleted')
                            });
                        });
                    })
                };

                $scope.resetRateLimiter = function () {
                    ApiService.installations($stateParams.id, 'reset-alarm-limiter', {
                        idSite: $stateParams.id
                    }, 'POST').then(function () {
                        locale.ready('alarms').then(function () {
                            $scope.rateLimited = false;
                            vrmNotificationsService.add({
                                type: vrmNotificationType.SUCCESS,
                                message: locale.getString('alarms.rate_limiter_reset')
                            });
                        });
                    })
                };

                $scope.toggleNoDataAlarm = function () {
                    if (!$scope.nodataalarm['noDataAlarmActive']) {
                        $scope.nodataalarm['noDataAlarmTimeout'] = null;
                    } else if ($scope.nodataalarm['noDataAlarmTimeout'] == null) {
                        $scope.nodataalarm['noDataAlarmTimeout'] = 300; // Default 5 minutes
                    }

                    if ($scope.installation.view_permissions.update_settings) {
                        ApiService.installationSettings($stateParams.id, {
                            noDataAlarmTimeout: $scope.nodataalarm['noDataAlarmTimeout'],
                        }, false).then(function () {
                            $scope.installation.noDataAlarmTimeout = $scope.nodataalarm['noDataAlarmTimeout']
                        });
                    }
                }

                $scope.alarmSettingsHasChanged = function () {
                    if ($scope.installation.noDataAlarmTimeout !== $scope.nodataalarm['noDataAlarmTimeout']) {
                        return true;
                    }
                    for (var i in $scope.alarms) {
                        var alarm = $scope.alarms[i];

                        if (alarm.idDataAttribute && $scope.attributes[alarm.idDataAttribute].dataType == 'enum') {
                            //Create list of active alarm states
                            alarm.active = [];
                            _.each(alarm.toggles, function (val, key) {
                                if (!val) {
                                    alarm.active.push(parseInt(key));
                                }
                            });

                            //Remove empty list of states for correct change comparsion
                            if (alarm.active == undefined || alarm.active.length == 0) {
                                delete alarm.active;
                            }
                        }

                        //Check for changes in alarm
                        if (!_.isEqual(_.omit(alarm, 'copy', 'toggles', 'collapsed', '$$hashKey'), alarm.copy)) {
                            return true
                        }
                    }
                }

                $scope.updateNoDataAlarmTimeout = function () {
                    ApiService.installationSettings($stateParams.id, {
                        noDataAlarmTimeout: $scope.nodataalarm['noDataAlarmTimeout'],
                    }, true).then(function () {
                        $scope.installation.noDataAlarmTimeout = $scope.nodataalarm['noDataAlarmTimeout']
                    });
                };

                $scope.updateAutomaticAlarm = function () {
                    if ($scope.installation.view_permissions.update_settings) {
                        ApiService.installationSettings($stateParams.id, {
                            alarmMonitoring: $scope.automaticalarm['alarmMonitoring']
                        }, false).then(function (response) {
                            if (!response.data.success) {
                                return;
                            }

                            $scope.installation.alarmMonitoring = response.data.data.alarmMonitoring;
                        });
                    }
                };

                $scope.cancel = function () {
                    $scope.nodataalarm['noDataAlarmTimeout'] = $scope.installation.noDataAlarmTimeout
                    for (var i in $scope.alarms) {
                        $scope.alarms[i] = {...$scope.alarms[i], ...$scope.alarms[i].copy};
                    }
                };

                $scope.preventNonNumericalInput = function (event) {
                    // Necessary to verify using this for the following reasons
                    // 1) firefox allows chars in input type number
                    // 2) Firefox's ParseFloat method crashes when you enter a comma but not in chrome
                    // 3) Validators are not ran at all when entering a char which makes it
                    // impossible to throw a proper validation error

                    const e = event || window.event;
                    var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
                    var charStr = String.fromCharCode(charCode);

                    const inputFieldvalue = event.currentTarget.value;
                    const charactersAllowedOnce = ['+', '-', '.'];

                    if (!charStr.match(/^[+-.]|[0-9]/)) {
                        e.preventDefault();
                    } else {
                        //cannot use regex further as we need to then predict the output
                        if (charactersAllowedOnce.includes(charStr) && inputFieldvalue.includes(charStr)) {
                            e.preventDefault();
                        }
                    }
                };

                $scope.save = function () {
                    var promises = [];

                    if (!$scope.forms.alarms.$valid) {
                        vrmNotificationsService.add({
                            type: vrmNotificationType.ERROR,
                            message: locale.getString('alarms.contains_error')
                        });
                        $scope.forms.alarms.$submitted = true;
                        return;
                    } else {
                        $scope.forms.alarms.$submitted = false;
                    }

                    if ($scope.nodataalarm['noDataAlarmTimeout'] !== $scope.installation.noDataAlarmTimeout) {
                        if ($scope.installation.view_permissions.update_settings) {
                            ApiService.installationSettings($stateParams.id, {
                                noDataAlarmTimeout: $scope.nodataalarm['noDataAlarmTimeout'] === "" ? null : $scope.nodataalarm['noDataAlarmTimeout'],
                            }, false);
                        }
                    }

                    //Save other alarms
                    for (var i in $scope.alarms) {
                        var alarm = $scope.alarms[i];

                        if (alarm.idDataAttribute && $scope.attributes[alarm.idDataAttribute].dataType == 'enum') {
                            //Create list of active alarm states
                            alarm.active = [];
                            _.each(alarm.toggles, function (val, key) {
                                if (!val) {
                                    alarm.active.push(parseInt(key));
                                }
                            });

                            //Remove empty list of states for correct change comparsion
                            if (alarm.active == undefined || alarm.active.length == 0) {
                                delete alarm.active;
                            }
                        }

                        //Check for changes in alarm
                        if (!_.isEqual(_.omit(alarm, 'copy', 'toggles', 'collapsed', '$$hashKey'), alarm.copy)) {
                            promises.push(updateAlarm(alarm));
                        }
                    }

                    $q.all(promises).then(function () {
                        locale.ready('core').then(function () {
                            vrmNotificationsService.add({
                                type: vrmNotificationType.SUCCESS,
                                message: locale.getString('core.settings_saved')
                            });
                        });
                    });
                };
            });
        });

        $scope.rateLimited = false;
    }
})();
